import * as React from 'react';
export const playFilledSvg = React.forwardRef(function playFilledSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 1.332A1 1 0 0 1 3.54.49l7.263 4.668a1 1 0 0 1 0 1.682L3.54 11.51A1 1 0 0 1 2 10.668V1.332Z',
    }),
  );
});
playFilledSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var playFilled = {
  category: 'icon',
  colorable: true,
  name: 'playFilled',
  svg: playFilledSvg,
};
